export default "__VITE_ASSET__DepZEPz1__"